import {
	WeaTop,
	WeaRightMenu,
	WeaDialogFooter,
} from 'ecCom';
import {
	observer
} from 'mobx-react';
import Content from './Content';

@observer
export default class Top extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const {
			store
		} = this.props, {
			TOP,
			top,
			pageLoading,
			topButtons,
			footerButtons,
			dropMenuDatas,
		} = store;

		if (false) { //隐藏头部
			return (
				<WeaTop 
	               {...TOP}
	               {...top}
	               loading={pageLoading}
	               buttons={topButtons}
	               dropMenuDatas={dropMenuDatas}
	            >
	            	<WeaRightMenu datas={dropMenuDatas}>
	            		<Content store={store}/>
	            	</WeaRightMenu>
	            </WeaTop>
			);
		} else {
			return (
				<WeaRightMenu datas={dropMenuDatas}>
            		<Content store={store}/>
            		<WeaDialogFooter buttons={footerButtons} moreBtn={{datas:[]}}/>
            	</WeaRightMenu>
			)
		}


	}
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/group/Top.js